import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild
} from '@angular/core';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { ICompany } from '../../../interfaces/company/company';
import { IMultiSelectOption, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { Modal } from 'src/app/components/modal/Modal';
import { CostCenterService } from 'src/app/services/cost-center.service';
import { CostCenterFormComponent } from 'src/app/components/cost-center-form/cost-center-form.component';
import { CropperComponent } from '../../../directives/cropper/cropper.component';
import { base64toBlob } from '../../../utils/images';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-internal-registration-company',
  templateUrl: './internal-registration-company.component.html',
  providers: [RequestsServices, StorageService, UserService, CostCenterService],
  encapsulation: ViewEncapsulation.None
})

export class InternalRegistrationCompanyComponent extends PageBase implements OnInit {
  @ViewChild('costCenterForm') costCenterForm: CostCenterFormComponent;
  @ViewChild('modalConfirmDelete') modalConfirmDelete: Modal;
  @ViewChild('modalCostCenter') modalCostCenter: Modal;
  @ViewChild('crop') public cropper: CropperComponent;


  selectUnitId: string;
  pagination: any = {};
  isLoading: boolean;
  activeAccount: any;
  company: ICompany;
  editMode = false;
  unitsList = [];
  error: string;
  public showImageDiv: boolean;

  headerList = ['Nome', 'CNPJ', 'Código', 'Tipo de Endereço'];
  optionsUnit: IMultiSelectOption[] = [
    { id: 'holding', name: 'Faturamento por Matriz' },
    { id: 'group', name: 'Faturamento por grupo' }
  ];
  settingsSelectUnit: IMultiSelectSettings = {
    enableSearch: false,
    maxHeight: '111px',
    checkedStyle: 'fontawesome',
    closeOnSelect: true,
    autoUnselect: true,
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 2,
    selectionLimit: 1,
    displayAllSelectedText: true
  };

  constructor(
    private translate: TranslateService,
    private toasterService: ToasterService,
    private request: RequestsServices,
    private userService: UserService,
    private costCenterService: CostCenterService) {
    super();
    const languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.activeAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();

    if (typeBusiness === 'company' && this.activeAccount) {
      this.getCompany(this.activeAccount.id);
    } else {
      this.toasterService.info('Erro', 'Conta de empresa inválida.', false, 2500);
    }

    this.pagination.pageNumber = 1;
    this.pagination.pageSize = 15;
    this.getCostCenters(0);
  }

  setSkip(newPageNumber: number): number {
    return (newPageNumber - 1) * this.pagination.pageSize;
  }

  nextPage(): void {
    if (this.pagination.pageNumber < this.pagination.totalPages) {
      this.getCostCenters(this.setSkip(this.pagination.pageNumber += 1));
    }
  }

  previousPage(): void {
    if (this.pagination.pageNumber > 1) {
      this.getCostCenters(this.setSkip(this.pagination.pageNumber -= 1));
    }
  }

  getTotalPagesSearch(count): void {
    this.pagination.totalPages = Math.ceil(count / this.pagination.pageSize);
  }

  getCostCenters(pageSkip) {
    console.log('internal-registration-company', 'cost centers load!!!');
    const params = [
      { param: 'companyId', value: this.activeAccount.id, },
      { param: 'limit', value: this.pagination.pageSize },
      { param: 'skip', value: pageSkip }
    ];

    this.costCenterService.getCostCenters(params).then(res => {
      this.unitsList = res.data;
      this.getTotalPagesSearch(res.count);
    });
  }

  private getCompany(companyId): void {
    this.isLoading = true;
    this.request.get({ path: 'companies', pathParam: `/${companyId}` }).then((company) => {
      this.company = company;
      this.isLoading = false;

      if (this.company.image_key) {
        this.showImageDiv = true;
      }

      if (!this.company.revenues) {
        this.company.revenues = 'holding';
      }

      if (!this.company.urls || !this.company.urls.url_website) {
        this.company.urls = { url_website: '' };
      }

    }, () => {
      this.error = 'Erro ao consultar os dados da empresa. Tente novamente mais tarde.';
      this.isLoading = false;
    });
  }

  public getImage(event): void {
    if (!event) {
       return;
    }

    const imgBase64 = this.cropper.crop();
    this.showImageDiv = true;
    this.saveImageAndUrl(true, imgBase64);
  }

  private saveImageAndUrl(isUpdateImage: boolean, imgBase64: string): void {
    const image_key_name = this.cropper.getImageName();
    const timeStamp = 6000;

    if (isUpdateImage) {
      if (imgBase64 && imgBase64 !== '') {
        const blob = base64toBlob(imgBase64);
        const formData = new FormData();
        formData.append('company', blob, image_key_name);

        this.isLoading = true;
        this.request.post('storage', formData, environment.BUCKET_UPLOAD_IMAGE).then(() => {
        const args = {editableImageComponent: this, image_key: this.cropper.getWebpKey('company', image_key_name)};
        setTimeout(this.afterLambdaProcessImage, timeStamp, args);
        });
      } else {
        // Reset image
        this.company.image = null;
        this.company.image_key = null;
        this.request.put('companies', this.company).then((company) => {
          this.isLoading = false;
        });
      }
    }
  }

  afterLambdaProcessImage({editableImageComponent, image_key}){
    editableImageComponent.company.image_key = image_key;
    editableImageComponent.request.put('companies', editableImageComponent.company).then((company) => {
      editableImageComponent.isLoading = false;
    });
  }

  clearImage(): void {
    this.cropper.reset();
    this.showImageDiv = false;
    this.company.image = '';
    const imgBase64 = "";
    this.saveImageAndUrl(true, imgBase64);
  }

  public updateCompany(): void {
    this.isLoading = true;

    if (!this.company.name) {
      this.toasterService.info(
        'Atenção',
        'Preencha o nome da empresa.', false, 2000);
    }

    this.request.put('companies', this.company).then((company) => {
      this.isLoading = false;
      if (company) {
        this.userService.requestAccountConfig();
        this.toasterService.info(
          'Sucesso', 'Dados de empresa salvos com sucesso.', true, 2000);
      }
    }, () => {
      this.toasterService.info(
        'Oops!', 'Não foi possível atualizar os dados.', false, 2000);
    });
  }

  openModal(unit?) {
    this.editMode = !!(unit);
    unit = { ...unit, companyId: this.activeAccount.id };

    this.costCenterForm.chargeCostCenterForm(unit);
    this.modalCostCenter.open();
  }

  closeModal(event) {
    if (event) {
      this.modalConfirmDelete.close();
      this.modalCostCenter.close();
      this.getCostCenters(0);
    }
  }

  confirmModal(id) {
    this.selectUnitId = id;
    this.modalConfirmDelete.open();
  }

  removeUnit() {
    this.costCenterService.deleteCostCenters(this.selectUnitId).then(() => {
      this.toasterService.info(
        'Sucesso', 'Unidade removida com sucesso.', true, 2500);
      this.closeModal(true);
      this.getCostCenters(0);
    }, (err) => {
      if (err.status === 409) {
        this.toasterService.info(
          'Oops!', 'Não foi possível remover, pois existem colaboradores vinculados a este grupo.', false, 3000);
      } else {
        this.toasterService.info(
          'Oops!', 'Não foi possível remover esta unidade.', false, 3000);
      }
      this.closeModal(true);
    });
  }

  getWebImageUrl(key): string {
    if (key) {
      return `${environment.CDN_IMAGES_WEB}/${key}`;
    }
    return this.company.image;
  }

  getMobileImageUrl(key): string {
    if (key) {
      return `${environment.CDN_IMAGES_APP}/${key}`;
    }
    return this.company.image;
  }

}
